import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Footer = styled.footer`
    margin-top: 4rem;
    padding-top: 2rem;
    background-color: ${props => props.theme.darkGrey};
    color: ${props => props.theme.background};
    @media screen and (min-width: 768px) {
        display: flex;
        justify-content: center;
        padding-bottom: 2rem;
        padding-left: 12.5%;
    }
`

const FooterInner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 768px) {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    @media screen and (min-width: 1300px) {
        max-width: 85vw;
    }
    @media screen and (min-width: 1500px) {
        max-width: 75vw;
    }
`

const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 1.5rem;
    width: 96%;
    padding: 0 2%;
    h3 {
        padding: 0.75rem 0;
    }
    p {
        font-weight: 300;
        font-size: 0.825rem;
        padding: 0;
        letter-spacing: 1px;
        margin: 0;
        color: ${props => props.theme.lightGrey};
    }
    a {
        color: inherit;
        text-decoration: none;
        font-size: 0.825rem;
        padding: 2px;
        letter-spacing: 1px;
        &:hover {
            opacity: 0.7;
        }
    }
    @media screen and (min-width: 768px) {
        justify-content: flex-start;
        align-items: flex-start;
    }
`

const SMContainer = styled(SectionContainer)`
    margin-top: 1rem;
    width: 100%;
    padding: 0 1rem;
    box-sizing: border-box;
    div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        border-top: 1px solid ${props => props.theme.background};
        padding: 2rem 0;
        a img {
            height: 35px;
            padding: 0 0.25rem;
        }
        @media screen and (min-width: 768px) {
            justify-content: flex-start;
            padding: 1rem 0;
        }
    }
    @media screen and (min-width: 768px) {
        padding: 0;
        width: 50%;
    }
`

const SectionInner = styled(SectionContainer)`
    padding-top: 0;
    columns: 2;
    display: block;
    padding: 0;
    a {
        display: inline-block;
    }
    @media screen and (min-width: 768px) {
        columns: 1;
        display: flex;
        flex-direction: column;
    }
`

export default function footer({ data }) {
    return (
        <Footer>
            <FooterInner>
                {data.section_headings.map(sectionName => {
                    if (sectionName !== "Connect") {
                        return (
                            <SectionContainer key={sectionName}>
                                <h3>{sectionName}</h3>
                                <SectionInner>
                                    {data.links.map((link, key) => {
                                        if (link.section === sectionName) {
                                            return (
                                                <a
                                                    key={key}
                                                    href={link.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {link.name}
                                                </a>
                                            )
                                        } else return null
                                    })}
                                </SectionInner>
                            </SectionContainer>
                        )
                    } else {
                        return (
                            <SectionContainer key={sectionName}>
                                <h3>{sectionName}</h3>
                                <p>{data.contact_information.name}</p>
                                <p>{data.contact_information.address}</p>
                                <p>
                                    {data.contact_information.city},{" "}
                                    {data.contact_information.state}{" "}
                                    {data.contact_information.postal_code}
                                </p>
                                <a href="tel:1-800-289-8833">
                                    {data.contact_information.phone}
                                </a>
                                <SMContainer>
                                    <div>
                                        {data.social_media_links.map(
                                            (link, key) => {
                                                return (
                                                    <a
                                                        key={key}
                                                        href={Link.url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img
                                                            alt={
                                                                link.name +
                                                                " logo"
                                                            }
                                                            src={`https://www.tuffshed.com/wp-content/themes/tsretail/assets/images/${link.name.toLowerCase()}.png`}
                                                        />
                                                    </a>
                                                )
                                            }
                                        )}
                                    </div>
                                </SMContainer>
                            </SectionContainer>
                        )
                    }
                })}
            </FooterInner>
        </Footer>
    )
}
